import { useEffect } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";

function Contact() {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-wrapper">
    <Header />
<div className="content-wrapper">
    
    {/* About section start */}
  <section className="about-wrap style3 pt-30">
    <div className="container">
      <div className="row">
        <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div className="section-title style2 text-center mb-10">
            <h2>Contact Us</h2>
            
          </div>
        </div>
      </div>
     
    </div>
  </section>
  {/* About section end */}

 {/* Contact Us section Start */}
  <section className="contact-us-wrap ptb-100">
    <div className="container">
      <div className="row justify-content-center pb-75">
        {/* <div className="col-xl-4 col-lg-4 col-md-6">
          <div className="contact-item">
            <span className="contact-icon">
              <i className="flaticon-map" />
            </span>
            <div className="contact-info">
              <h3>Visit Us Anytime</h3>
              <p>
                342/A Brooklyn St, Milson Avenue, <br /> New York, USA
              </p>
            </div>
          </div>
        </div> */}
        <div className="col-xl-6 col-lg-6 col-md-6">
          <div className="contact-item">
            <span className="contact-icon">
              <i className="flaticon-email-2" />
            </span>
            <div className="contact-info">
              <h3>Send An Email</h3>
              <a>
                <span className="__cf_email__" >
                  info@landpanda.com
                </span>
              </a>
             
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6">
          <div className="contact-item">
            <span className="contact-icon">
              <i className="flaticon-call-2" />
            </span>
            <div className="contact-info">
              <h3>Call Us</h3>
              <a href="tel:+91-7992799230">+91-7992799230</a>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
       
        <div className="col-lg-12 col-12">
          <div className="contact-form">
            <form className="form-wrap" id="contactForm">
              <div className="row">
                <h3>Connect with us </h3>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name*"
                      id="name"
                      required=""
                      data-error="Please enter your name"
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      required=""
                      placeholder="Email*"
                      data-error="Please enter your email"
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <input
                      type="text"
                      name="msg_subject"
                      placeholder="Subject*"
                      id="msg_subject"
                      required=""
                      data-error="Please enter your subject"
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group v1">
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Your Messages.."
                      cols={30}
                      rows={10}
                      required=""
                      data-error="Please enter your message"
                      defaultValue={""}
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-check checkbox">
                    <input
                      name="gridCheck"
                      defaultValue="I agree to the terms and privacy policy."
                      className="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      required=""
                    />
                    <label className="form-check-label" htmlFor="gridCheck">
                      I agree to the{" "}
                      <a className="link style1" href="terms-of-service.html">
                        Terms &amp; Conditions
                      </a>{" "}
                      and{" "}
                      <a className="link style1" href="privacy-policy.html">
                        Privacy Policy
                      </a>
                    </label>
                    <div className="help-block with-errors gridCheck-error" />
                  </div>
                </div>
                <div className="col-md-12">
                  <button type="submit" className="btn style2">
                    Send Message
                  </button>
                  <div id="msgSubmit" className="h3 text-center hidden" />
                  <div className="clearfix" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Contact Us section End */}

  </div>
    <Footer /></div>
    </>
  );
}

export default Contact;
